// extracted by mini-css-extract-plugin
var _1 = "ApplicantCreditCheckSkeleton-moduleApplicantCreditCheckSkeleton__TXmFe";
var _2 = "ApplicantCreditCheckSkeleton-moduleskeletonLine__RgWiI Skeleton-moduleSkeleton__Mlrfv";
var _3 = "ApplicantCreditCheckSkeleton-moduleskeletonTitle__ZRuzc Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "ApplicantCreditCheckSkeleton", _2 as "skeletonLine", _3 as "skeletonTitle" }
